import { z } from 'zod';

import {
    schemaTemplatesDivisionFooter,
    schemaTemplatesDivisionHeader,
    schemaTemplatesDivisionMail,
    schemaTemplatesMail,
    schemaTemplatesMailFooter,
    schemaTemplatesMailHeader,
    schemaTemplatesMailSignature,
    schemaTemplatesOffer,
    schemaTemplatesSystemMail,
} from './discriminatedUnions';

// export type TemplatesTableSchema = {
//     createdAt: number;
//     id: string;
//     name: string | null;
//     priority: number | null;
//     users: string[] | null;
// } & (
//     | {
//           data: Omit<EventSchema<Template_MailCreated>, 'name' | 'type' | 'priority'>;
//           type: typeof TEMPLATE_TYPES.MAIL;
//       }
//     | { data: Omit<EventSchema<Template_SMSCreated>, 'name' | 'type' | 'priority'>; type: typeof TEMPLATE_TYPES.SMS }
//     | { data: Omit<EventSchema<Template_SystemMailCreated>, 'name' | 'type'>; type: typeof TEMPLATE_TYPES.SYSTEM_MAIL }
//     | {
//           data: Omit<EventSchema<Template_MailSignatureCreated>, 'name' | 'priority' | 'users'>;
//           type: typeof TEMPLATE_TYPES.MAIL_SIGNATURE;
//       }
//     | { data: Omit<EventSchema<Template_MailHeaderCreated>, 'type'>; type: typeof TEMPLATE_TYPES.MAIL_HEADER }
//     | { data: Omit<EventSchema<Template_MailFooterCreated>, 'type'>; type: typeof TEMPLATE_TYPES.MAIL_FOOTER }
// );

export const TemplatesTableDefinitionZod = z.discriminatedUnion('type', [
    schemaTemplatesMail,
    schemaTemplatesMailHeader,
    schemaTemplatesMailFooter,
    schemaTemplatesMailSignature,
    schemaTemplatesSystemMail,
    schemaTemplatesDivisionMail,
    schemaTemplatesDivisionHeader,
    schemaTemplatesDivisionFooter,
    schemaTemplatesOffer,
]);

export type TemplatesTableSchema = z.infer<typeof TemplatesTableDefinitionZod>;
export type TemplatesTableSchemaMail = z.infer<typeof schemaTemplatesMail>;
export type TemplatesTableSchemaMailHeader = z.infer<typeof schemaTemplatesMailHeader>;
export type TemplatesTableSchemaMailFooter = z.infer<typeof schemaTemplatesMailFooter>;
export type TemplatesTableSchemaMailSignature = z.infer<typeof schemaTemplatesMailSignature>;
export type TemplatesTableSchemaSystemMail = z.infer<typeof schemaTemplatesSystemMail>;
export type TemplatesTableSchemaDivisionMail = z.infer<typeof schemaTemplatesDivisionMail>;
export type TemplatesTableSchemaDivisionHeader = z.infer<typeof schemaTemplatesDivisionHeader>;
export type TemplatesTableSchemaDivisionFooter = z.infer<typeof schemaTemplatesDivisionFooter>;
export type TemplatesTableSchemaOffer = z.infer<typeof schemaTemplatesOffer>;
